import { IPlaceAddressForm } from 'features/Places/types'
import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

const cityMessages = defineMessages({
  required: {
    id: 'places.new.form.city.required',
    defaultMessage: 'The city is required'
  }
})

const line1Messages = defineMessages({
  required: {
    id: 'places.new.form.address.line1.required',
    defaultMessage: 'The street is required'
  },
  max: {
    id: 'places.new.form.address.line1.max',
    defaultMessage: 'The street can be up to 255 characters'
  }
})

const line2Messages = defineMessages({
  max: {
    id: 'places.new.form.address.line2.max',
    defaultMessage: 'The additional information can be up to 255 characters'
  }
})

const zipCodeMessages = defineMessages({
  required: {
    id: 'places.new.form.address.zipCode.required',
    defaultMessage: 'The ZIP code is required'
  },
  regex: {
    id: 'places.new.form.address.zipCode.regex',
    defaultMessage: 'The format for a ZIP code is wrong'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IPlaceAddressForm> => {
  return yup.object().shape({
    directions: yup.string().optional(),
    city: yup.object().shape({
      name: yup.string().required(intl.formatMessage(cityMessages.required)),
      id: yup.string().required(),
      countryCode: yup.string().required(),
      stateCode: yup.string().required()
    }),
    address: yup.object().shape({
      line1: yup
        .string()
        .required(intl.formatMessage(line1Messages.required))
        .max(255, intl.formatMessage(line1Messages.max)),
      line2: yup.string().max(255, intl.formatMessage(line2Messages.max)),
      zipCode: yup
        .string()
        .required(intl.formatMessage(zipCodeMessages.required))
        .matches(/^([a-za-z0-9]{5,15})*$/, intl.formatMessage(zipCodeMessages.regex)),
      countryCode: yup.string().required()
    }),
    photo: yup.object().shape({
      name: yup.string(),
      path: yup.string(),
      file: yup.mixed()
    })
  })
}
